import { state } from "./state.js";

// ─── El cliente de un documento ──────────────────────────────────────────────
// Un documento puede referirse a su cliente de dos maneras:
//
//   1. `cliente_id` → una ficha del maestro de Clientes (el caso normal).
//   2. `_clienteLibre` → un tercero NO REGISTRADO, escrito a mano sobre el
//      documento. Sirve para cotizarle a un prospecto sin ensuciar el maestro
//      con fichas de gente que quizá nunca compre.
//
// Para que el resto del sistema no tenga que preguntar cuál de los dos casos
// es, `clienteDeDoc` devuelve SIEMPRE un objeto con la misma forma que una
// ficha de cliente. El tercero libre se marca con `_libre:true` por si alguna
// pantalla quiere advertirlo (o impedir algo, como facturar electrónicamente).
//
// Nunca devuelve null: un documento sin cliente da `{}`, igual que hacía el
// `|| {}` que estaba repartido por todo el código.

export function esClienteLibre(doc) {
  return !!(doc && doc._clienteLibre && String(doc._clienteLibre.nombre || "").trim());
}

export function clienteDeDoc(doc) {
  if (!doc) return {};
  if (esClienteLibre(doc)) {
    const l = doc._clienteLibre;
    return {
      id: "",
      nombre: String(l.nombre || "").trim(),
      nit: l.nit || "",
      telefono: l.telefono || "",
      email: l.email || "",
      direccion: l.direccion || "",
      ciudad: l.ciudad || "",
      // Un tercero libre no tiene ficha, así que tampoco tiene contactos
      // guardados: el contacto de la cotización se escribe en el momento y
      // viaja embebido en el propio documento (`_contacto`).
      _contactos: [],
      _libre: true
    };
  }
  return (state.data.clientes || []).find(c => c.id === doc.cliente_id) || {};
}

export function nombreClienteDoc(doc, vacio = "—") {
  return clienteDeDoc(doc).nombre || vacio;
}
